/**
***DEPRECATED: null days returned for unlimited products***
displayDays(null) => 'Unlimited'
displayDays(1) => 1
*/
const displayDays = days => {
  if (days === null) {
    return 'Unlimited'
  }

  return days
}

/**
displayPlanDaysRemaining(null, { label: false }) => "Unlimited"
displayPlanDaysRemaining(null) => "Unlimited Days Remaining"
displayPlanDaysRemaining(0) => "0 Days Remaining"
displayPlanDaysRemaining(1) => "1 Day Remaining"
displayPlanDaysRemaining(2) => "2 Days Remaining"
*/
const displayPlanDaysRemaining = (plan, opts) => {
  const {
    days: { balance },
    unlimited
  } = plan

  const { label = true } = opts || {}

  return displayDaysRemaining({ balance, unlimited, label })
}

const displayDaysRemaining = ({ balance, unlimited, label }) => {
  const amount = unlimited ? 'Unlimited' : balance

  if (label) {
    const pluralDays = balance === 1 ? 'Day' : 'Days'
    return [amount, pluralDays, 'Remaining'].join(' ')
  }

  return amount
}

export { displayDays, displayPlanDaysRemaining, displayDaysRemaining }
